const taskObjects = [
  {
    id: 1,
    description: "Your order of tyrion hoodie is yet to be completed",
    day: "Today",
  },
  {
    id: 2,
    description: "Your order of tyrion hoodie is yet to be completed",
    day: "1 day ago",
  },
  {
    id: 3,
    description: "Your order of tyrion hoodie is yet to be completed",
    day: "10 days ago",
  },
  {
    id: 4,
    description: "Your order of tyrion hoodie is yet to be completed",
    day: "6 days ago",
  },
];

export default taskObjects;
